import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  alert("Missing Supabase environment variables. Please check your .env file.");
  throw new Error(
    "Missing Supabase environment variables. Please check your .env file."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  db: {
    schema: "public",
  },
});

// Helper function to handle Supabase errors
export const handleSupabaseError = (error) => {
  console.error("Supabase error:", error);

  if (error.code === "PGRST116") {
    return { error: "Database connection failed. Please try again." };
  }

  if (error.code === "42501") {
    return { error: "Access denied. Please check your permissions." };
  }

  if (error.code === "23505") {
    return { error: "This record already exists." };
  }

  return { error: error.message || "An unexpected error occurred." };
};

// Helper function to validate required fields
export const validateRequiredFields = (data, requiredFields) => {
  const missingFields = [];

  requiredFields.forEach((field) => {
    if (
      !data[field] ||
      (typeof data[field] === "string" && data[field].trim() === "")
    ) {
      missingFields.push(field);
    }
  });

  if (missingFields.length > 0) {
    return {
      error: `Missing required fields: ${missingFields.join(", ")}`,
    };
  }

  return { success: true };
};
